const serialize = (formElement) => {
  let data = new FormData(formElement);
  let obj = {};
  for (let [key, value] of data) {
    obj[key] = value;
  }
  return obj;
}
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
                        constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton.classList.contains('loading')) return;
    this.handleErrorMessage();
    this.cartNotification.setActiveElement(document.activeElement);
    $('button[type="submit"]').attr('aria-disabled', true);
    $('button[type="submit"]').addClass('loading');
    $('.loading-overlay__spinner').removeClass('hidden');
    var id = parseInt((serialize(this.form)).id);
    var quantity = parseInt((serialize(this.form)).quantity);
    var selling_plan = parseInt((serialize(this.form)).selling_plan);

    var product_form_obj = this;
    add_items_to_cart(id, quantity, 'show_popup', product_form_obj, selling_plan);
  }
  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});
}